import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MessageModel } from '../../model.module/modals.model';
import { MessageObservable } from '../../services.module/message.observable';

@Component({
    selector: 'elem-message',
    templateUrl: './message.component.html',
    styleUrls: ['./modals.component.less'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MessageComponent {

    modalClass = 'modal dialog hide';

    message: MessageModel = null;

    txtClose = 'Schließen';

    performAction = null;

    timeoutHandle = null;

    constructor(
        private readonly messageObservable: MessageObservable,
    ) {
        this.messageObservable.subscribe((message: MessageModel) => {
            if (message !== null) {
                this.performAction = null;
                this.timeoutHandle = null;
                this.message = message;
                this.modalClass = 'modal dialog show';
            }
        });
    }

    close(): void {
        if (this.timeoutHandle) {
            clearTimeout(this.timeoutHandle);
        }

        if (this.performAction) {
            this.performAction();
        }

        this.message = null;
        this.modalClass = 'modal dialog hide';
    }

}
